module.exports = __webpack_public_path__ + "assets/img/home-servicePrice-zyzq-light.b30c9fee.png";